module.exports = __webpack_public_path__ + "static/img/图层 535.eb4c9b97.png";